// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XXMe","content":"styles_content__3ARk7","tableWrap":"styles_tableWrap__C1IbC"};